import type { SlideshowStatus } from '@/types/api'
import { SLIDESHOW_SORTS, STATUS_FILTERS, type SlideshowSort } from './status'

/** `/slideshows` search params. */
export interface SlideshowsSearch {
  search?: string
  status?: SlideshowStatus
  sort?: SlideshowSort
  /** Open the create dialog (deep link / command palette). */
  create?: true
}

const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v.trim() : undefined)

export function validateSlideshowsSearch(s: Record<string, unknown>): SlideshowsSearch {
  return {
    search: str(s.search),
    status: STATUS_FILTERS.includes(s.status as SlideshowStatus) ? (s.status as SlideshowStatus) : undefined,
    sort: SLIDESHOW_SORTS.includes(s.sort as SlideshowSort) ? (s.sort as SlideshowSort) : undefined,
    create: s.create === true || s.create === 'true' || s.create === 1 || s.create === '1' ? true : undefined,
  }
}

/** `/slideshows/$id/preview` — `?version=<id>` plays a published version instead of the draft. */
export function validatePreviewSearch(s: Record<string, unknown>): { version?: string } {
  return { version: str(s.version) }
}
